import { useCallback } from 'react';

export const useMonthDetailsHooks = ({
  isPsaPrpRevenueSchedulePageOptimizationEnabled,
  refreshRevenueSchedule,
  transitionToRevenueRunUpdate,
  refetchMonthDetails,
  createRevenueContractScriptRecalculationBatch,
  createUpdateRevenueRunBatch,
  deleteRevenueRunBatchUri,
  deleteProjectRevenueRecognitionBatchUri,
  refetchLastRevenueRunDetails,
  revenueRunUri,
  monthStartDate,
  setPreviousBatchInProgress,
  setNonBaseCurrencyFailureUri
}) => {
  const onRecalculateClick = useCallback(() => {
    if (isPsaPrpRevenueSchedulePageOptimizationEnabled) {
      refreshRevenueSchedule({
        date: {
          year: monthStartDate.c.year,
          month: monthStartDate.c.month,
          day: monthStartDate.c.day
        },
        revenueRunUri
      });
    } else {
      createRevenueContractScriptRecalculationBatch({
        date: {
          year: monthStartDate.c.year,
          month: monthStartDate.c.month,
          day: monthStartDate.c.day
        }
      });
    }
  }, [
    isPsaPrpRevenueSchedulePageOptimizationEnabled,
    refreshRevenueSchedule,
    createRevenueContractScriptRecalculationBatch,
    monthStartDate,
    revenueRunUri
  ]);

  const onCreateRevenueContractScriptRecalculationBatchComplete = useCallback(async () => {
    setPreviousBatchInProgress({ batchUri: null, batchStatus: null });
    setNonBaseCurrencyFailureUri(null);
    if (isPsaPrpRevenueSchedulePageOptimizationEnabled) {
      await transitionToRevenueRunUpdate({ revenueRunUri });
    } else {
      await refetchLastRevenueRunDetails();
      await deleteRevenueRunBatchUri();
      await deleteProjectRevenueRecognitionBatchUri();
      createUpdateRevenueRunBatch({ revenueRunUri });
    }
  }, [
    isPsaPrpRevenueSchedulePageOptimizationEnabled,
    setPreviousBatchInProgress,
    setNonBaseCurrencyFailureUri,
    transitionToRevenueRunUpdate,
    refetchLastRevenueRunDetails,
    deleteRevenueRunBatchUri,
    deleteProjectRevenueRecognitionBatchUri,
    createUpdateRevenueRunBatch,
    revenueRunUri
  ]);

  const onRevenueRunBatchComplete = useCallback(async () => {
    setPreviousBatchInProgress({ batchUri: null, batchStatus: null });
    setNonBaseCurrencyFailureUri(null);
    if (isPsaPrpRevenueSchedulePageOptimizationEnabled) {
      await refetchMonthDetails();
    } else {
      await refetchLastRevenueRunDetails();
      await deleteRevenueRunBatchUri();
    }
  }, [
    isPsaPrpRevenueSchedulePageOptimizationEnabled,
    setPreviousBatchInProgress,
    setNonBaseCurrencyFailureUri,
    refetchMonthDetails,
    refetchLastRevenueRunDetails,
    deleteRevenueRunBatchUri
  ]);

  return {
    onRecalculateClick,
    onCreateRevenueContractScriptRecalculationBatchComplete,
    onRevenueRunBatchComplete
  };
};

export default useMonthDetailsHooks;
